<app-dialog [showCloseBtn]="true" size="small">
  <div class="logout-dialog-header text-center" dialogContent>
    {{ 'NEW_DOCUMENT_MODAL.TEXT_1' | translate }}
    <a [mat-dialog-close]="true" routerLink="/main/my-docs">{{ 'NEW_DOCUMENT_MODAL.TEXT_2' | translate }}</a>
    {{ 'NEW_DOCUMENT_MODAL.TEXT_3' | translate }}
  </div>
</app-dialog>
